import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';
import type {
  GalleryGridItemAttributes,
  GridItemAttributes,
} from 'hb-react/backoffice/types/builder/itemAttributes/galleryItemAttributes';

import ContentItem from './ContentItem';

// Force children to be GridItems
interface ItemContentProp
  extends Omit<DocumentItem<GalleryGridItemAttributes>, 'children'> {
  children: DocumentItem<GridItemAttributes>[];
}

interface ContentProps
  extends Omit<ComponentSettingsTab<GalleryGridItemAttributes>, 'item'> {
  item: ItemContentProp;
}

const Content = ({ item, onChange }: ContentProps) => {
  const children = item?.children || [];

  return (
    <ContentWrapper>
      {children.map((child, index) => (
        <ContentItem
          index={index}
          key={child.id}
          item={child}
          onChange={onChange}
        />
      ))}
    </ContentWrapper>
  );
};

export default Content;

const ContentWrapper = styled(Box).attrs(() => ({
  flexDirection: 'column',
  width: '100%',
}))``;
